import { addToast } from "@heroui/react";
import { t } from "@lingui/core/macro";

const SUPPORT_EMAIL = "support@lime-booking.com";
const TOAST_TIMEOUT_MS = 12000;

/**
 * A toast rather than a page banner: the button that triggers this lives in the
 * sidebar, which covers the page on mobile, so a banner would open behind it.
 * The stretched link makes the whole message a tap target — it sizes to the
 * `content` slot, so the close button stays clickable.
 */
export function showSupportChatBlockedToast() {
  addToast({
    color: "warning",
    timeout: TOAST_TIMEOUT_MS,
    title: t`Klepeta s podporo ni bilo mogoče odpreti`,
    description: (
      <>
        {t`Videti je, da nalaganje preprečuje blokirnik oglasov ali zaščita zasebnosti v brskalniku. Onemogočite jo za to stran in jo osvežite, ali se dotaknite tega sporočila in nam pišite po e-pošti.`}
        <a
          aria-label={t`Pišite nam na ${SUPPORT_EMAIL}`}
          className="absolute inset-0"
          href={`mailto:${SUPPORT_EMAIL}`}
        />
      </>
    ),
  });
}
